// src/config/analytics.js
import ReactGA from 'react-ga4';

// Initialize with your Google Analytics 4 tracking ID
export const initGA = () => {
  ReactGA.initialize('G-SH7X89SM71'); 
};

// Set debug mode based on hostname
if (window.location.hostname === 'localhost') {
  ReactGA.set({ debug_mode: true });
}

export const logPageView = () => {
  ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
};
